jQuery(document).ready(function ($) {
  if ($('body').hasClass('page-template-ocrolus-2024')) {
    const chart2024Q3FutureGrowth = document.getElementById('2024-q3-futuregrowth');

    new Chart(chart2024Q3FutureGrowth, {
      type: 'bar',
      data: {
        labels: ['Q4 2023', 'Q1 2024', 'Q2 2024', 'Q3 2024'],
        datasets: [{
          label: 'Significant Growth',
          data: ['25.8', '30.8', '29.83', '27.2'],
          backgroundColor: '#0064dd',
          borderColor: '#0064dd',
        },
        {
          label: 'Moderate Growth',
          data: ['65.8', '61.8', '62.2', '65.0'],
          backgroundColor: '#000082',
          borderColor: '#000082',
        },
        {
          label: 'No Growth',
          data: ['8.4', '7.3', '8.5', '7.8'],
          backgroundColor: '#83dcc1',
          borderColor: '#83dcc1',
        }]
      },
      options: {
        plugins: {
          tooltip: {
            callbacks: {
              label: function (context) {
                let label = context.dataset.label || '';

                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  label += context.parsed.y + '%';
                }
                return label;
              }
            }
          },
        },
        scales: {
          x: {
            grid: { display: false },
          },
          y: {
            border: { display: false },
            ticks: {
              stepSize: 10,
              callback: function (value, index, ticks) {
                return Chart.Ticks.formatters.numeric.apply(this, [value, index, ticks]) + '%';
              }
            },
            max: 70,
          }
        }
      }
    });

    const chart2024Q3AltPay = document.getElementById('2024-q3-altpay');

    new Chart(chart2024Q3AltPay, {
      type: 'line',
      data: {
        labels: ['Jul\'23', 'Aug\'23', 'Sep\'23', 'Oct\'23', 'Nov\'23', 'Dec\'23', 'Jan\'24', 'Feb\'24', 'Mar\'24', 'Apr\'24', 'May\'24', 'Jun\'24', 'Jul\'24', 'Aug\'24', 'Sep\'24'],
        datasets: [{
          label: 'Percentage of Businesses|Accepting Alternative Payments',
          data: ['20.38', '20.56', '20.14', '20.30', '19.80', '19.90', '20.86', '22.03', '22.97', '23.83', '24.73', '24.26', '25.13', '24.89', '25.26'],
          borderColor: '#0064dd',
          pointBackgroundColor: '#0064dd',
        }]
      },
      options: {
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: function (context) {
                let label = context.dataset.label || '';

                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  label += context.parsed.y + '%';
                }
                return label.split("|");
              }
            }
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: 'Month / Year',
            },
            grid: {
              color: '#fff',
              tickLength: -6,
            },
            ticks: {
              maxRotation: 45,
              minRotation: 45
            },
          },
          y: {
            border: { display: false },
            title: {
              display: true,
              text: 'Percentage',
            },
            ticks: {
              stepSize: 2,
              callback: function (value, index, ticks) {
                return Chart.Ticks.formatters.numeric.apply(this, [value, index, ticks]) + '%';
              }
            },
            min: 18,
            max: 28,
          }
        }
      }
    });

    const chart2024Q3Median = document.getElementById('2024-q3-median');

    new Chart(chart2024Q3Median, {
      type: 'bar',
      data: {
        labels: ['Q3 2023', 'Q4 2023', 'Q1 2024', 'Q2 2024', 'Q3 2024'],
        datasets: [{
          label: 'Median Monthly Revenue',
          data: ['60992', '64137', '58568', '56717', '54928'],
          backgroundColor: 'transparent',
          borderWidth: [{
            left: 0,
            right: 0,
            top: 10,
          }],
          borderColor: '#0064dd',
        }]
      },
      options: {
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: function (context) {
                let label = context.dataset.label || '';

                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  label += new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(context.parsed.y);
                }
                return label;
              }
            }
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: 'Quarter / Year',
            },
            grid: { display: false },
          },
          y: {
            title: {
              display: true,
              text: 'Median Monthly Revenue',
            },
            border: { display: false },
            ticks: {
              stepSize: 10000,
              callback: function (value, index, ticks) {
                return '$' + Chart.Ticks.formatters.numeric.apply(this, [value, index, ticks]);
              }
            },
            min: 30000,
            max: 70000,
          }
        }
      }
    });
  }
});
